import { DownPaymentMethod } from '@linqpal/models/src/dictionaries/downPayment'
import { DownPaymentWireOptions } from './DownPaymentWireOptions'
import { IDownPaymentDetails } from '@linqpal/models/src/types/routes'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { DownPaymentCardOptions } from './DownPaymentCardOptions'
import { Spacer } from '../../../../../ui/atoms'
import { StyleSheet, View } from 'react-native'
import { BtPlainText, BtRadioGroup } from '@linqpal/components/src/ui'
import { PropertyList } from '../../../../../ui/molecules/PropertyList'
import { toCurrency, toPercentage } from '@linqpal/models/src/helpers/formatter'
import { TooltipLabel } from '../../../../../ui/atoms/TooltipLabel'
import RootStore from '../../../../../store/RootStore'

interface IDownPaymentFormProps {
  downPayment: IDownPaymentDetails
  onChange: (downPayment: IDownPaymentDetails) => void
}

export const DownPaymentForm: FC<IDownPaymentFormProps> = ({
  downPayment,
  onChange,
}) => {
  const { t } = useTranslation('global')

  const downPaymentPercentage =
    RootStore.userStore.company?.settings?.downPaymentDetails
      ?.downPaymentPercentage

  const handlePaymentMethodChange = (method: DownPaymentMethod) => {
    // console.log('=>(DownPaymentForm.tsx:40) method', method)
    onChange({
      ...downPayment,
      paymentMethod: method,
      accountId: method === DownPaymentMethod.Wire ? '' : downPayment.accountId,
    })
  }

  const handleCardChange = (id: string) => {
    onChange({
      ...downPayment,
      paymentMethod: DownPaymentMethod.Card,
      accountId: id,
    })
  }

  return (
    <View>
      <BtPlainText style={styles.title}>
        {t('DownPaymentModal.title')}
      </BtPlainText>
      <Spacer height={20} />

      <PropertyList
        // eslint-disable-next-line i18next/no-literal-string
        theme="gray"
        data={[
          {
            name: t('DownPaymentModal.downPaymentPercentage'),
            value: toPercentage(downPaymentPercentage),
          },
          {
            name: t('DownPaymentModal.downPaymentAmount'),
            value: toCurrency(downPayment.amount),
          },
        ]}
      />
      <Spacer height={20} />

      <TooltipLabel
        label={t('DownPaymentModal.selectPaymentMethod')}
        tooltip={t('DownPaymentModal.paymentMethodTooltip')}
        tooltipTitle={t('DownPaymentModal.paymentMethodTooltipTitle')}
        labelStyle={styles.boldLabel}
      />
      <Spacer height={5} />

      <BtRadioGroup
        value={downPayment.paymentMethod}
        options={[
          {
            label: t('DownPaymentModal.payWithCard'),
            value: DownPaymentMethod.Card,
          },
          {
            label: t('DownPaymentModal.payWithWire'),
            value: DownPaymentMethod.Wire,
          },
        ]}
        onChange={handlePaymentMethodChange}
        groupStyle={styles.radioGroup}
        labelStyle={styles.radioButtonLabel}
        testID="down-payment-type"
      />
      <Spacer height={10} />

      {downPayment.paymentMethod === DownPaymentMethod.Wire ? (
        <DownPaymentWireOptions />
      ) : (
        <DownPaymentCardOptions
          cardAccountId={downPayment.accountId ?? ''}
          onChange={handleCardChange}
        />
      )}
    </View>
  )
}

const styles = StyleSheet.create({
  title: {
    fontSize: 24,
    fontWeight: '700',
    lineHeight: 34,
    letterSpacing: -0.5,
  },
  radioGroup: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    columnGap: 32,
  },
  radioButtonLabel: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 24,
    color: '#001929',
  },
  boldLabel: {
    fontWeight: '600',
  },
})
